// extracted by mini-css-extract-plugin
export default {"header":"HeaderList_header__pjR1M","header__icon":"HeaderList_header__icon__Qq1wC","header__title":"HeaderList_header__title__pS2RU"};